import React from 'react';

import { type ContextResolver } from '../../../common/types';
import { type AppRecommendationsProviderValue } from '../types';

export default React.createContext<AppRecommendationsProviderValue>({
	onEvents: () => {},
	contextResolver: {} as ContextResolver,
});
